moduleViewApp.controller('itemsCtrl', ['$scope', '$timeout', '$filter', 'DebugHelper', 'moduleContextService', 'myPartnersService', 'itemsContentService', '$routeParams', 'toastHelper', (
    $scope, $timeout, $filter, DebugHelper, moduleContextService, myPartnersService, itemsContentService, $routeParams, toastHelper) ->
  DebugHelper.register("itemsCtrl", $scope)

  _.assignIn $scope,
    itemsLoaded: false
    items: []

    fetchItems: ->
      moduleContextService.fetchModule($routeParams.set_id, 'set').then (module) ->
        $scope.set = module
        itemsContentService.fetchItems($routeParams.set_id).then (items) ->
          $scope.items = items
          for item in $scope.items
            item.templatePartial = Packs.iKnowRoutes.sets_v2_templates_path(item.template_type)
            if $scope.set.learn_version == 4
              item.itemEditPath = Packs.iKnowRoutes.edit_v4_edit_set_item_path($scope.set.id, item.id)
            else
              item.itemEditPath = Packs.iKnowRoutes.edit_v3_create_set_item_path($scope.set.id, item.id)
            item.template = item[item.template_type]
          $scope.itemsLoaded = true

          # IE hack. For some reason the container needs specific width or
          # the height will equal to sum of heights of all items in the columns
          if bowser.msie
            $timeout ->
              angular.element("#module--items-columns").width(angular.element("#module--items-columns").width())

  $scope.fetchItems()

  myPartnersService.initialize().then () ->
    $scope.partner = myPartnersService.currentProductPartner
])
